import { Box, List } from "@mui/material";
import { NavDrawer } from "../../../features/navigation/ui/NavDrawer";
import { SiteSelector } from "../../../features/site-selection";
import { useUserContext } from "../../../providers/useUserProvider";
import { AuthNavProps } from "./AuthNav";

/**
 * AuthNavDrawer
 *
 * A navigation drawer for authenticated users. Integrates with user context to provide site selection and navigation.
 * Renders a responsive drawer with a SiteSelector and any additional children.
 *
 * @param {AuthNavDrawerProps} props - The props for the AuthNavDrawer component.
 * @returns {JSX.Element} The rendered navigation drawer.
 */
export const AuthNavDrawer: React.FC<AuthNavProps> = ({
    open,
    isMobile,
    onDrawerToggle,
    onWidthChange,
}) => {
    const { allowedSites, selectedSite, setSelectedSite, isReady } =
        useUserContext();

    const drawerContent = (
        <List>
            <SiteSelector
                allowedSites={allowedSites}
                selectedSite={selectedSite}
                setSelectedSite={setSelectedSite}
            />
        </List>
    );

    return (
        <Box sx={{ display: "flex" }}>
            {isReady && (
                <NavDrawer
                    open={open}
                    isMobile={isMobile}
                    onDrawerToggle={onDrawerToggle}
                    onWidthChange={onWidthChange}
                >
                    {drawerContent}
                </NavDrawer>
            )}
        </Box>
    );
};
